export class State {
  public static fromJson(json: any): State {
    return new State(json.name, json.abbreviation);
  }

  public static fromJsonArray(array): State[] {
    return array.map(State.fromJson);
  }

  constructor(public name: string, abbreviation: string) {}
}
